import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ApiService, RegistrationStep } from 'angular-lib';
import { CompleterItem, CompleterService, RemoteData } from 'ng2-completer';
import { Headers } from '@angular/http';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'ez-location',
    template: require('./location.component.html'),
    styles: [require('./location.component.less')],
    encapsulation: ViewEncapsulation.None
})
export class LocationComponent extends RegistrationStep implements OnInit {
    public cityRemoteData: RemoteData;

    constructor(
        private apiService: ApiService,
        private completerService: CompleterService
    ) {
        super();
    }

    public ngOnInit() {
        if (!this.registrationModel.countryId
            || !this.registrationModel.city.id
            || !this.registrationModel.city.value) {
            this.apiService.locateUser().subscribe((data) => {
                this.registrationModel.countryId = data.country.id;
                this.registrationModel.city = {
                    value: data.city.name,
                    id: data.city.id
                };
            });
        }

        this.cityRemoteData = this.completerService.remote(
            null,
            null,
            'value');
        this.cityRemoteData.headers(new Headers({
            Accept: 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem(environment.tokenName)
        }));

        this.cityRemoteData.urlFormater(term => {
            return this.apiService.autocompleteurl + '?q=' + term + '&countryId=' + this.registrationModel.countryId;
        });
    }

    public citySelected(item: CompleterItem) {
        this.registrationModel.city = item.originalObject;
    }

    public save() {
        this.request = this.apiService.saveLocation(this.registrationModel.city.id)
            .subscribe(_ => {
            this.submit();
            this.request = null;
        });
    }
}




// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/components/registration/location/location.component.ts